import React from 'react';
import PropTypes from 'prop-types';

export default function FormSectionHeading({ heading }) {
  return <p className="ppvx_text--xl guest-form-section-heading">{heading}</p>;
}

FormSectionHeading.propTypes = {
  heading: PropTypes.string,
};
